import React from "react";
import DocumentUploadField from "../elements/document-upload-field";

export default function Dischargeslip(props: any) {
  return (
    <DocumentUploadField
      title="Discharge slip/notice"
      onUploaded={props.setDischargeslip}
    />
  );
}
